<template>
  <!-- 创新服务内容详情页 -->
  <div class="innovateDetail">
    <div class="container">
      <!-- 导航条 -->
      <div class="nav">
        <span>当前位置：</span>
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/innovateService' }">创新服务</el-breadcrumb-item>
          <el-breadcrumb-item>{{detailInfo.programName}}</el-breadcrumb-item>
          <el-breadcrumb-item>{{detailInfo.title}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <!-- 详情及右侧列表 -->
      <div class="detail">
        <div class="detail-left">
          <div class="empty" v-if="!detailInfo.content">暂无数据</div>
          <div v-html="detailInfo.content"></div>
        </div>
        <div class="detail-right">
          <div class="detail-title">全部服务</div>
          <div class="Line"></div>
          <div class="innovate" v-for="item in innovateList" :key="item.uuid">
            {{ item.name }}
            <div
              class="item"
              v-for="el in item.innovateServiceList"
              :key="el.uuid"
              @click="clickItem(el.uuid)"
              :class="curUuid == el.uuid ? 'cur' : ''"
            >{{ el.title }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { searchRc, innovateDetail } from "../../utils/interface";
export default {
  name: "",
  components: {},
  props: {},
  data() {
    return {
      innovateList: [],
      curUuid: "",
      detailInfo: {}
    };
  },
  watch: {},
  computed: {},
  created() {},
  mounted() {
    this.searchRc();
    if (this.$route.query.uuid) {
      this.clickItem(this.$route.query.uuid);
    }
  },
  methods: {
    // 创新服务列表查询
    searchRc() {
      searchRc().then(res => {
        if (res.success && res.data.length > 0) {
          this.innovateList = res.data;
        } else {
          this.innovateList = [];
        }
      });
    },
    clickItem(uuid) {
      this.curUuid = uuid;
      console.log("uuid:", uuid);
      innovateDetail(uuid).then(res => {
        if (res.success && Object.keys(res.data).length > 0) {
          this.detailInfo = res.data;
        } else {
          this.detailInfo = {};
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.innovateDetail {
  background-color: #f4f4f4;

  .empty {
    font-size: 24px;
    font-weight: 500;
    color: #5566779e;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  .container {
    width: 1300px;
    margin: 0 auto;
    padding-bottom: 20px;

    .nav {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-bottom: 25px;
      padding-top: 25px;

      span {
        font-size: 14px;
      }
    }

    .detail {
      width: 1300px;
      min-height: 400px;
      margin: 0 auto;
      display: flex;
      flex-flow: row nowrap;

      .detail-left {
        flex: 1;
        max-width: 980px;
        margin: 0 10px;
        background-color: #ffffff;
        box-sizing: border-box;
        padding: 20px 40px;
        position: relative;
      }

      .detail-right {
        width: 298px;
        padding: 10px 20px;
        box-sizing: border-box;
        background-color: #ffffff;
        // border-bottom: 4px solid #f9f9f9;

        .Line {
          width: 280px;
          height: 2px;
          margin-top: 7px;
          border-bottom: 1px solid #dddddd;
        }

        .detail-title {
          font-size: 18px;
          font-weight: bold;
        }

        .innovate {
          font-size: 16px;
          font-weight: bold;
          margin-top: 20px;

          .cur {
            color: #fff;
            background-color: #2d50a16e;
          }

          .item {
            font-size: 14px;
            font-weight: normal;
            position: relative;
            margin-left: 20px;
            margin-top: 10px;
            padding-left: 5px;
            border-radius: 4px;
            cursor: pointer;

            &::before {
              position: absolute;
              content: "";
              width: 4px;
              height: 4px;
              left: -10px;
              top: 50%;
              transform: translateY(-50%);
              border-radius: 50%;
              background-color: #000;
            }
          }
        }
      }
    }
  }

  /deep/ .el-breadcrumb__inner.is-link:hover {
    color: #2d50a1;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/innovateService/innovateDetail.vue